module.exports = __webpack_public_path__ + "img/shamanzs-animation-1.c44e90d7.gif";